import React from 'react';

const LogoRaioX: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7154 9H38.2848L33.9515 17.6667H8.38208L12.7154 9ZM13.9515 11L11.6181 15.6667H32.7154L35.0487 11H13.9515Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.04867 22.3333H31.6181L27.2847 31H1.71533L6.04867 22.3333ZM7.28473 24.3333L4.9514 29H26.0487L28.382 24.3333H7.28473Z"
      />
    </svg>
  );
};

export default LogoRaioX;
